import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/60">Loading…</div>;

  if (!user) {
    // Choose the best login page for the requested area
    let target = "/parent/login";
    if (roles?.includes("member") && !roles.includes("parent")) target = "/member/login";
    else if (roles?.includes("coach") && !roles.includes("parent")) target = "/coach/login";
    else if (roles?.includes("staff") && !roles.includes("parent")) target = "/management/login";
    else if (roles?.includes("admin") && !roles.includes("parent")) target = "/admin/login";
    return <Navigate to={target} replace state={{ from: location.pathname }} />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  // Force password change on first login for accounts admin created
  if (user.must_change_password && !location.pathname.endsWith("/change-password")) {
    const dest =
      user.role === "parent" ? "/parent/change-password" :
      user.role === "coach"  ? "/coach/change-password" :
      "/admin/change-password";
    if (location.pathname !== dest) {
      return <Navigate to={dest} replace />;
    }
  }

  return children;
}
